export const EventNames = {
  LCM_LOGIN_SUCCESS: "LCM_LOGIN_SUCCESS",
  LCM_LOGIN_FAILURE_OTP_GENERATION: "LCM_LOGIN_FAILURE_OTP_GENERATION",
  LCM_LOGIN_FAILURE_OTP_VERIFICATION: "LCM_LOGIN_FAILURE_OTP_VERIFICATION",
  LCM_LOGIN_FAILURE_OTP_ATTEMPTS_EXCEEDED:
    "LCM_LOGIN_FAILURE_OTP_ATTEMPTS_EXCEEDED",
  LCM_CARD_TAB_VIEW_SUCCESS: "LCM_CARD_TAB_VIEW_SUCCESS",
  LCM_HISTORY_TAB_VIEW_SUCCESS: "LCM_HISTORY_TAB_VIEW_SUCCESS",
  LCM_REWARDS_TAB_VIEW_SUCCESS: "LCM_REWARDS_TAB_VIEW_SUCCESS",
  LCM_MANAGE_TAB_VIEW_SUCCESS: "LCM_MANAGE_TAB_VIEW_SUCCESS",
  LCM_DEPOSIT_TAB_VIEW_SUCCESS: "LCM_DEPOSIT_TAB_VIEW_SUCCESS",
  LCM_PAY_BILL_REDIRECT_SUCCESS: "LCM_PAY_BILL_REDIRECT_SUCCESS",
  LCM_BILL_SUMMARY_VIEW_SUCCESS: "LCM_BILL_SUMMARY_VIEW_SUCCESS",
  LCM_CARD_DETAILS_VIEW_SUCCESS: "LCM_CARD_DETAILS_VIEW_SUCCESS",
  LCM_CARD_DETAILS_VIEW_FAILURE_OTP_GENERATION:
    "LCM_CARD_DETAILS_VIEW_FAILURE_OTP_GENERATION",
  LCM_CARD_DETAILS_VIEW_FAILURE_VERIFICATION:
    "LCM_CARD_DETAILS_VIEW_FAILURE_VERIFICATION",
  LCM_CARD_DETAILS_VIEW_FAILURE_ATTEMPTS_EXCEEDED:
    "LCM_CARD_DETAILS_VIEW_FAILURE_ATTEMPTS_EXCEEDED",
  LCM_HISTORY_MORE_CLICK_SUCESS: "LCM_HISTORY_MORE_CLICK_SUCESS",
  LCM_HISTORY_TRANSACTION_DETAIL_VIEW_SUCCESS:
    "LCM_HISTORY_TRANSACTION_DETAIL_VIEW_SUCCESS",
  LCM_HISTORY_CONVERT_TO_EMI_VIEW_SUCCESS:
    "LCM_HISTORY_CONVERT_TO_EMI_VIEW_SUCCESS",
  LCM_HISTORY_CONVERT_TO_EMI_SUCCESS: "LCM_HISTORY_CONVERT_TO_EMI_SUCCESS",
  LCM_HISTORY_CONVERT_TO_EMI_FAILURE_API:
    "LCM_HISTORY_CONVERT_TO_EMI_FAILURE_API",

  LCM_DEPOSIT_INCREASE_AMOUNT_ENTER_SUCCESS:
    "LCM_DEPOSIT_INCREASE_AMOUNT_ENTER_SUCCESS",
  LCM_DEPOSIT_INCREASE_AMOUNT_REDIRECT_SUCCESS:
    "LCM_DEPOSIT_INCREASE_AMOUNT_REDIRECT_SUCCESS",
  LCM_DEPOSIT_WITHDRAW_SUCCESS: "LCM_DEPOSIT_WITHDRAW_SUCCESS",
  LCM_DEPOSIT_WITHDRAW_FAILURE_API: "LCM_DEPOSIT_WITHDRAW_FAILURE_API",

  LCM_CONTROLS_UNLOCK_SUCCESS: "LCM_CONTROLS_UNLOCK_SUCCESS",
  LCM_CONTROLS_UNLOCK_FAILURE: "LCM_CONTROLS_UNLOCK_FAILURE",
  LCM_CONTROLS_UPDATE_SUCCESS: "LCM_CONTROLS_UPDATE_SUCCESS",
  LCM_CONTROLS_UPDATE_FAILURE_OTP: "LCM_CONTROLS_UPDATE_FAILURE_OTP",
  LCM_CONTROLS_UPDATE_FAILURE_API: "LCM_CONTROLS_UPDATE_FAILURE_API",
  LCM_CARD_PIN_UPDATE_SUCCESS: "LCM_CARD_PIN_UPDATE_SUCCESS",
  LCM_CARD_PIN_UPDATE_FAILURE_API: "LCM_CARD_PIN_UPDATE_FAILURE_API",
  LCM_MONTHLY_STATEMENT_ACCESS_SUCCESS: "LCM_MONTHLY_STATEMENT_ACCESS_SUCCESS",
  LCM_MONTHLY_STATEMENT_ACCESS_FAILURE_OTP:
    "LCM_MONTHLY_STATEMENT_ACCESS_FAILURE_OTP",
  LCM_MONTHLY_STATEMENT_ACCESS_FAILURE_API:
    "LCM_MONTHLY_STATEMENT_ACCESS_FAILURE_API",
  LCM_INCREASE_LIMIT_OFFER_AVAILABLE: "LCM_INCREASE_LIMIT_OFFER_AVAILABLE",
  LCM_INCREASE_LIMIT_OFFER_SUCCESS: "LCM_INCREASE_LIMIT_OFFER_SUCCESS",
  LCM_INCREASE_LIMIT_OFFER_FAILURE_OTP: "LCM_INCREASE_LIMIT_OFFER_FAILURE_OTP",
  LCM_INCREASE_LIMIT_OFFER_FAILURE_API: "LCM_INCREASE_LIMIT_OFFER_FAILURE_API",
  LCM_INCREASE_LIMIT_OFFER_EXPIRED: "LCM_INCREASE_LIMIT_OFFER_EXPIRED",
  LCM_INCREASE_LIMIT_OFFER_NOT_AVAILABLE:
    "LCM_INCREASE_LIMIT_OFFER_NOT_AVAILABLE",
  LCM_CUSTOMER_SUPPORT_REDIRECTED: "LCM_CUSTOMER_SUPPORT_REDIRECTED",
  LCM_CARD_TEMPORARY_BLOCK_SUCCESS: "LCM_CARD_TEMPORARY_BLOCK_SUCCESS",
  LCM_CARD_TEMPORARY_BLOCK_FAILURE_API: "LCM_CARD_TEMPORARY_BLOCK_FAILURE_API",
  LCM_CARD_TEMPORARY_UNBLOCK_FAILURE_API:
    "LCM_CARD_TEMPORARY_UNBLOCK_FAILURE_API",
  LCM_CARD_PERMANENT_BLOCK_SUCCESS: "LCM_CARD_PERMANENT_BLOCK_SUCCESS",
  LCM_CARD_PERMANENT_BLOCK_FAILURE_OTP: "LCM_CARD_PERMANENT_BLOCK_FAILURE_OTP",
  LCM_CARD_PERMANENT_BLOCK_FAILURE_API: "LCM_CARD_PERMANENT_BLOCK_FAILURE_API",
  LCM_KOTAK_API_FAILURE: "LCM_KOTAK_API_FAILURE",
  LCM_AXIS_API_FAILURE: "LCM_AXIS_API_FAILURE",

  // Bridge/session instrumentation
  TRACK_TOKEN_REGENERATION_SUCCESS: "TRACK_TOKEN_REGENERATION_SUCCESS",
  TRACK_SESSION_MANAGEMENT: "TRACK_SESSION_MANAGEMENT",
  TRACK_BRIDGE_DATA_INITIALIZATION: "TRACK_BRIDGE_DATA_INITIALIZATION",
  TRACK_BRIDGE_DATA_INJECTION: "TRACK_BRIDGE_DATA_INJECTION"
} as const;

export type EventName = typeof EventNames[keyof typeof EventNames];
